import React from 'react';

const index = () => (
	<h1>Under Construction</h1>
	)

export default index;


// WEBPACK FOOTER //
// ./src/pages/advance/accessibility/index.jsx